import React from "react";
import { Link } from "react-router-dom";
import "./login.css";
import GoogleAuth from "./components/GoogleAuth";

export default function Login() {
  return (
    <div className="Auth-form-container">
      <div className="left-section">
        <h1>1:1 Tutoring</h1>
        <h2>Built around you</h2>
        <p>Taught one to one by people who build AI systems for a living</p>
      </div>
      
      <div className="right-section">
        <form className="Auth-form">
          <div className="Auth-form-content">
            <h3>Welcome Back</h3>
            <p className="sign-in-text">Sign in to continue to your account</p>
            <div className="w-100">
              <GoogleAuth />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
